import * as React from "react";
import { styled } from "@mui/material/styles";
import Checkbox, { CheckboxProps } from "@mui/material/Checkbox";

// interface checkProps {
//     defaultChecked: boolean,
// }

const BpIcon = styled("span")(({ theme }) => ({
  borderRadius: 1,
  width: 12,
  height: 12,
  backgroundImage:
    theme.palette.mode === "dark"
      ? "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))"
      : "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
  border: "1px solid #575757",
  ".Mui-focusVisible &": {
    outline: "2px auto rgba(19,124,189,.6)",
    outlineOffset: 2,
  },
  "input:disabled ~ &": {
    boxShadow: "none",
    background:
      theme.palette.mode === "dark"
        ? "rgba(57,75,89,.5)"
        : "rgba(206,217,224,.5)",
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: "#000",
  backgroundImage:
    "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
  "&:before": {
    content: '""',
    position: "absolute",
    left: "-7px",
    top: "50%",
    height: "4px",
    width: "1px",
    background: "#fff",
    transform: "translateX(10px) rotate(-45deg)",
    transformOrigin: "left center",
  },
  "&:after": {
    content: '""',
    position: "absolute",
    left: "-3px",
    bottom: "3px",
    width: "7px",
    height: "1px",
    background: "#fff",
    transform: "translateX(8px) rotate(-45deg)",
    transformOrigin: "left center",
  },
});

// Inspired by blueprintjs
function BpCheckbox(props) {
  return (
    <Checkbox
      sx={{
        "&:hover": { bgcolor: "transparent" },
      }}
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      inputProps={{ "aria-label": "Checkbox demo" }}
      {...props}
    />
  );
}

const CustomCheckBox = (props) => {
  const { defaultChecked, checked, onClick, onChange } = props;
  return (
    <BpCheckbox
      defaultChecked={defaultChecked}
      checked={checked}
      onClick={onClick}
      onChange={onChange}
    />
  );
};

export default CustomCheckBox;
